// Máscaras de entrada para campos CPF/CNPJ, CEP, Telefone, Celular.
// Usa as mesmas regras de format do ~/Utils/Helpers.js, mas para uso em onChange/value.
// DW-0963 (CNPJ alfanumérico): o ramo 'cpf' preserva A-Z (uppercase) nas 12 primeiras
// posições do CNPJ; CPF (<=11) e os 2 dígitos verificadores permanecem numéricos.
// Espelha `somenteAlfanumerico` de src/validationSchemas.js e MASK_CNPJ_ALFANUMERICO
// (src/constant.js). Não converte para número (preserva letras p/ envio à API como string).

const aplicarMascara = (valor, tipo) => {
  if (!valor && valor !== 0) return '';

  // CPF/CNPJ: roteia pelo CONTEÚDO, não só pelo comprimento final.
  // - Qualquer letra [A-Z] => CNPJ alfanumérico (DW-0963), mesmo parcial (1-11 chars
  //   durante a digitação char-a-char). Isso impede que o \D-strip do ramo CPF apague
  //   as letras antes que o valor alcance 12 posições — bug do caso-ouro digitado.
  // - 12+ alfanuméricos => CNPJ (numérico ou alfanumérico).
  // - Puramente numérico e <= 11 => CPF. Para esses inputs `/[A-Z]/.test` é sempre
  //   false, então CPF e CNPJ numérico permanecem byte-idênticos ao comportamento legado.
  if (tipo === 'cpf') {
    // Normalização alfanumérica — espelha somenteAlfanumerico de validationSchemas.js.
    let alfanum = String(valor).toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (alfanum === '') return '';
    if (/[A-Z]/.test(alfanum) || alfanum.length > 11) {
      // CNPJ alfanumérico: 12 posições [A-Z0-9] + 2 DV numéricos → XX.XXX.XXX/XXXX-XX
      if (alfanum.length > 14) alfanum = alfanum.substring(0, 14);
      return alfanum.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{0,2}).*/, '$1.$2.$3/$4-$5');
    }
    // CPF permanece numérico (spec DW-0963): 999.999.999-99
    const cpf = String(valor).replace(/\D/g, '');
    if (cpf === '') return '';
    if (cpf.length > 9) {
      return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*/, '$1.$2.$3-$4');
    }
    if (cpf.length > 6) {
      return cpf.replace(/^(\d{3})(\d{3})(\d{0,3}).*/, '$1.$2.$3');
    }
    if (cpf.length > 3) {
      return cpf.replace(/^(\d{3})(\d{0,3}).*/, '$1.$2');
    }
    return cpf;
  }

  let digitos = String(valor).replace(/\D/g, '');
  if (digitos === '') return '';

  switch (tipo) {
    case 'cep':
      // CEP: 99999-999
      if (digitos.length > 8) digitos = digitos.substring(0, 8);
      if (digitos.length > 5) {
        return digitos.replace(/^(\d{5})(\d{0,3}).*/, '$1-$2');
      }
      return digitos;

    case 'fone':
      // Fixo: (99) 9999-9999
      if (digitos.length > 10) digitos = digitos.substring(0, 10);
      if (digitos.length > 6) {
        return digitos.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
      }
      if (digitos.length > 2) {
        return digitos.replace(/^(\d{2})(\d{0,4}).*/, '($1) $2');
      }
      return digitos;

    case 'celular':
      // Celular: (99) 99999-9999 ou (99) 9999-9999
      if (digitos.length > 11) digitos = digitos.substring(0, 11);
      if (digitos.length > 10) {
        return digitos.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
      }
      if (digitos.length > 6) {
        return digitos.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
      }
      if (digitos.length > 2) {
        return digitos.replace(/^(\d{2})(\d{0,5}).*/, '($1) $2');
      }
      return digitos;

    default:
      return String(valor);
  }
};

export default aplicarMascara;
